import { JSXElementConstructor } from 'react'

import produce from 'immer'
import { Reducer } from 'redux';

import { LegislationAct, LegislationActNode, LegislationFolder, LegislationFolderCategory } from 'interfaces/legislation'
import {
  SET_LEGISLATION_FOLDERS,
  SET_LEGISLATION_FOLDERS_MAP,
  SET_LEGISLATION_ACT_ID_MAP,
  SET_LEGISLATION_ACT,
  SET_LEGISLATION_ACTS,
  SET_LEGISLATION_PATH,
  SET_LEGISLATION_WRAPPER_EDIT_MODE,
  SET_LEGISLATION_WRAPPER_ADMIN_BUTTON,
  SET_LEGISLATION_WRAPPER_CONTENT_EDITOR,
  SET_LEGISLATION_WRAPPER_TITLE_EDITOR,
  SET_LEGISLATION_ACT_NODES,
  SET_LEGISLATION_ACT_HOVER_ICON_MAP
} from 'redux/actions/types'
import { AdminButtonProps } from 'components/legislation/admin/AdminButton';
import { TitleEditorProps } from 'components/legislation/admin/TitleEditor';
import { ActHoverIconMap } from 'types/Legislation';

export interface LegislationState {
  folders: LegislationFolder[]|null;
  foldersMap:  Record<string, LegislationFolderCategory[]> |null;
  act: string|null;
  path: string|null;
  actNodes: Record<string, LegislationActNode>|null;
  actHoverIconMap: ActHoverIconMap;
  acts: LegislationAct[] | null;
  actIdMap: Record<string, LegislationAct> | null;
  editMode: boolean;
  AdminButton: JSXElementConstructor<AdminButtonProps> | null;
  ContentEditor: JSXElementConstructor<any> | null; // FIX ME
  TitleEditor: JSXElementConstructor<TitleEditorProps>| null;
}

const initialState: LegislationState = {
  folders: null,
  foldersMap: null,
  act: null,
  path: null,
  actNodes: null,
  actHoverIconMap: null,
  acts: null,
  actIdMap: null,
  editMode: false,
  AdminButton: null,
  ContentEditor: null,
  TitleEditor: null
}
const legislation: Reducer<LegislationState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEGISLATION_FOLDERS:
      return produce(state, draft => {
        draft.folders = action.folders
      })
    case SET_LEGISLATION_FOLDERS_MAP:
      return produce(state, draft => {
        draft.foldersMap = action.foldersMap
      })
    case SET_LEGISLATION_ACT_NODES:
      return produce(state, draft => {
        draft.actNodes = action.actNodes
      })
    case SET_LEGISLATION_ACT_HOVER_ICON_MAP:
      return produce(state, draft => {
        draft.actHoverIconMap = action.actHoverIconMap
      })
    case SET_LEGISLATION_ACT:
      return produce(state, draft => {
        draft.act = action.act
      })
    case SET_LEGISLATION_PATH:
      return produce(state, draft => {
        draft.path = action.path
      })
    case SET_LEGISLATION_ACT_ID_MAP:
      return produce(state, draft => {
        draft.actIdMap = action.actIdMap
      })
    case SET_LEGISLATION_ACTS:
      return produce(state, draft => {
        draft.acts = action.acts
      })
    case SET_LEGISLATION_WRAPPER_EDIT_MODE:
      return produce(state, draft => {
        draft.editMode = action.editMode
      })
    case SET_LEGISLATION_WRAPPER_ADMIN_BUTTON:
      return produce(state, draft => {
        draft.AdminButton = action.AdminButton
      })
    case SET_LEGISLATION_WRAPPER_CONTENT_EDITOR:
      return produce(state, draft => {
        draft.ContentEditor = action.ContentEditor
      })
    case SET_LEGISLATION_WRAPPER_TITLE_EDITOR:
      return produce(state, draft => {
        draft.TitleEditor = action.TitleEditor
      })
    default:
      return state
  }
}

export default legislation
